/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import setMinutes from 'date-fns/set_minutes';
import setHours from 'date-fns/set_hours';
import addHours from 'date-fns/add_hours';
import { Link } from 'react-router';
import { FormControl } from 'react-bootstrap';
import styles from './styles.scss';

const propTypes = {
  date: PropTypes.instanceOf(Date),
  onSelect: PropTypes.func.isRequired,
};

const defaultProps = {
  date: new Date(),
};

class MomentSelect extends React.Component {
  constructor(props) {
    super(props);
    const hour = props.date.getHours();
    this.state = {
      timezoom: Number(hour) > 11 ? 'pm' : 'am',
      date: props.date,
      hour,
      minute: '00',
    };
    this.minute = 0;
    this.hour = hour;
    this.day = props.date.getDate();
  }

  componentWillReceiveProps(nextProps) {
    const { date } = nextProps;
    if (!_.isEqual(date, this.props.date)) {
      this.setState({ date });
    }
  }

  handleAddHour() {
    const hour = Number(this.hour) + 1;
    this.handleChangeTime(this.minute, hour);
  }

  handleDecreaseHour() {
    const hour = Number(this.hour) - 1;
    this.handleChangeTime(this.minute, hour);
  }

  handleChangeHour(e) {
    let hour = _.trim(e.target.value);
    if (hour !== '') {
      hour = Number(hour);
      if (!_.isInteger(hour) || !_.inRange(hour, 0, 24)) {
        hour = this.hour;
      }
      this.handleChangeTime(this.minute, hour);
    } else if (hour === '') {
      this.setState({ hour: '' });
    }
  }

  handleAddMinute() {
    const minute = Number(this.minute) + 15;
    this.handleChangeTime(minute, this.hour);
  }

  handleDecreaseMinute() {
    const minute = Number(this.minute) - 15;
    this.handleChangeTime(minute, this.hour);
  }

  handleChangeMinute(e) {
    let minute = _.trim(e.target.value);
    if (minute !== '') {
      minute = Number(minute);
      if (!_.isInteger(minute) || !_.inRange(minute, 0, 60)) {
        minute = this.minute;
      }
      this.handleChangeTime(minute, this.hour);
    } else if (minute === '') {
      this.setState({ minute: '' });
    }
  }

  handleChangeTime(m, h) {
    let { date } = this.state;
    let minute = m;
    let hour = h;

    if (minute >= 60) {
      minute -= 60;
      hour += 1;
    } else if (minute < 0) {
      minute += 60;
      hour -= 1;
    }

    date = setMinutes(date, minute);
    date = setHours(date, 0);
    date = addHours(date, hour);

    hour = date.getHours();

    this.minute = minute;
    this.hour = hour;
    this.setState({ minute, hour, date });
    this.props.onSelect(date);
  }

  render() {
    const { hour, minute } = this.state;
    return (
      <div styleName="moment">
        <div styleName="items">
          <Link onClick={() => this.handleAddHour()}>
            <span className="glyphicon glyphicon-chevron-up" />
          </Link>
          <FormControl
            bsClass="aisz-form-control-f"
            type="number"
            value={hour}
            onChange={e => this.handleChangeHour(e)}
          />
          <Link onClick={() => this.handleDecreaseHour()}>
            <span className="glyphicon glyphicon-chevron-down" />
          </Link>
        </div>
        <div styleName="items">
          <Link onClick={() => this.handleAddMinute()}>
            <span className="glyphicon glyphicon-chevron-up" />
          </Link>
          <FormControl
            bsClass="aisz-form-control-f"
            type="number"
            value={minute}
            onChange={e => this.handleChangeMinute(e)}
          />
          <Link onClick={() => this.handleDecreaseMinute()}>
            <span className="glyphicon glyphicon-chevron-down" />
          </Link>
        </div>
        {/*<div styleName="items">
          <Link>
            <span className="glyphicon glyphicon-chevron-up" />
          </Link>
          <div styleName="timezoom">
            {kTimeZoom[locale][timezoom]}
          </div>
          <Link>
            <span className="glyphicon glyphicon-chevron-down" />
          </Link>
        </div>*/}
      </div>
    );
  }
}

MomentSelect.propTypes = propTypes;
MomentSelect.defaultProps = defaultProps;

const mapStateToProps = state => ({
  locale: state.intl.locale,
});

export default connect(
  mapStateToProps,
  null,
  )(injectIntl(CSSModules(
    MomentSelect,
    styles,
    { allowMultiple: true },
  )));




// WEBPACK FOOTER //
// ./src/components/MomentSelect/index.jsx